import { Button, ButtonProps } from "@mantine/core"
import { ReactNode } from "react"
import { IPermissionCode, usePermission } from "../permission"
import { ReasonTooltip } from "./reason-tooltip"

type Props = {
  /** Permission code required to use the button. */
  permission?: IPermissionCode
  /** Other reason the action is unavailable (status, missing selection). Shown like a missing permission. */
  disabledReason?: ReactNode
  /** Legacy behaviour: render `fallback` (null by default) instead of the button when the permission is missing. */
  hideWhenDenied?: boolean
  fallback?: ReactNode
  /** All standard Mantine Button props flow through */
  children: ReactNode
} & Omit<ButtonProps, "children"> & {
  onClick?: () => void
  type?: "button" | "submit" | "reset"
}

/**
 * Mantine Button gated by a `usePermission` code. Without the permission it stays visible but
 * aria-disabled, with a tooltip «Эрх хэрэгтэй: КОД» (DeHUB UI standard: never hide an action).
 */
export function PermissionButton({ permission, disabledReason, hideWhenDenied = false, fallback = null, children, ...buttonProps }: Props) {
  const perm = usePermission(permission!)
  const denied = !!permission && !perm.hasAccess
  if (denied && hideWhenDenied) {
    return <>{fallback}</>
  }
  return (
    <ReasonTooltip reason={denied ? perm.reason : disabledReason}>
      <Button {...buttonProps}>{children}</Button>
    </ReasonTooltip>
  )
}
